import { call, put, takeEvery } from "redux-saga/effects";

import * as apis from "../../../network/apis/companyPortalEmployees";
import {
  getCompanyUsersListMeta,
  normalizeCompanyUser,
  normalizeCompanyUsers,
} from "../../../containers/Company-portal/TeamsPermissions/employeeMappers";
import { showErrorMsg, showSuccessMsg } from "../../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

const extractListItems = (response) => response?.data?.data ?? [];

function* getCompanyUsersSaga({ payload }) {
  try {
    const response = yield call(apis.getCompanyUsers, payload);
    yield put(
      actions.getCompanyUsersResponse({
        list: normalizeCompanyUsers(extractListItems(response)),
        meta: getCompanyUsersListMeta(response),
      }),
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* createCompanyUserSaga({ payload }) {
  const { data, successMessage, onSuccess, onError } = payload || {};
  try {
    const response = yield call(apis.createCompanyUser, data);
    yield put(
      actions.createCompanyUserSuccess(
        normalizeCompanyUser(response?.data?.data?.data),
      ),
    );
    if (successMessage) yield showSuccessMsg(successMessage, true);
    else yield showSuccessMsg("addedSuccessfully");
    if (typeof onSuccess === "function") onSuccess(response);
  } catch (error) {
    const message = error?.response?.data?.message;
    yield put(actions.createCompanyUserFailure({ error: message }));
    if (message) yield showErrorMsg(message);
    if (typeof onError === "function") onError(error);
  }
}

function* getCompanyUserSaga({ payload }) {
  const { id, onError } = payload || {};
  try {
    const response = yield call(apis.getCompanyUser, id);
    yield put(
      actions.getCompanyUserResponse(
        normalizeCompanyUser(response?.data?.data),
      ),
    );
  } catch (error) {
    yield put(actions.getCompanyUserResponse(null));
    const message = error?.response?.data?.message;
    if (message) yield showErrorMsg(message);
    if (typeof onError === "function") onError(error);
  }
}

function* updateCompanyUserSaga({ payload }) {
  const { id, data, successMessage, onSuccess, onError } = payload || {};
  try {
    const response = yield call(apis.updateCompanyUser, { id, data });
    yield put(
      actions.updateCompanyUserSuccess(
        normalizeCompanyUser(response?.data?.data),
      ),
    );
    if (successMessage) yield showSuccessMsg(successMessage, true);
    if (typeof onSuccess === "function") onSuccess(response);
  } catch (error) {
    const message = error?.response?.data?.message;
    yield put(actions.updateCompanyUserFailure({ error: message }));
    if (message) yield showErrorMsg(message);
    if (typeof onError === "function") onError(error);
  }
}

function* deleteCompanyUserSaga({ payload }) {
  const { id, onSuccess, onError } = payload || {};
  try {
    const response = yield call(apis.deleteCompanyUser, id);
    yield put(actions.deleteCompanyUserSuccess({ id }));
    const message = response?.data?.message;
    if (message) yield showSuccessMsg(message, true);
    else yield showSuccessMsg("deletedSuccessfully");
    if (typeof onSuccess === "function") onSuccess(response);
  } catch (error) {
    const message = error?.response?.data?.message;
    yield put(actions.deleteCompanyUserFailure({ error: message }));
    if (message) yield showErrorMsg(message);
    if (typeof onError === "function") onError(error);
  }
}

export default function* companyEmployeesSagas() {
  yield takeEvery(types.GET_COMPANY_USERS_REQUEST, getCompanyUsersSaga);
  yield takeEvery(types.CREATE_COMPANY_USER_REQUEST, createCompanyUserSaga);
  yield takeEvery(types.GET_COMPANY_USER_REQUEST, getCompanyUserSaga);
  yield takeEvery(types.UPDATE_COMPANY_USER_REQUEST, updateCompanyUserSaga);
  yield takeEvery(types.DELETE_COMPANY_USER_REQUEST, deleteCompanyUserSaga);
}
